import * as Yup from 'yup';

const phoneRegex = /^1.*$/;

export const PhoneSchema = Yup.string()
  .required('Phone number is required')
  .matches(phoneRegex, 'Wrong country prefix');
export const addCountryCode = (phone = '') =>
  phone.startsWith('+1') ? phone : `+1${phone}`;

export const fPhoneNumber = (phone = '') =>
  phone.startsWith('+') ? phone : `+${phone}`;
